import { useEffect, useRef } from 'react';

const SCRIPT_SRC = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';

export function turnstileSiteKey() {
  const env = typeof import.meta !== 'undefined' ? import.meta.env : undefined;
  const key = env && env.VITE_TURNSTILE_SITE_KEY ? String(env.VITE_TURNSTILE_SITE_KEY).trim() : '';
  return key;
}

/**
 * Renders nothing until VITE_TURNSTILE_SITE_KEY is set. The server ignores a
 * missing token until TURNSTILE_SECRET_KEY is set as well.
 */
export default function TurnstileField({ onToken }) {
  const siteKey = turnstileSiteKey();
  const hostRef = useRef(null);
  const onTokenRef = useRef(onToken);
  onTokenRef.current = onToken;

  useEffect(() => {
    if (!siteKey || !hostRef.current) return undefined;
    let widgetId;
    let cancelled = false;

    function renderWidget() {
      if (cancelled || !hostRef.current || !window.turnstile) return;
      widgetId = window.turnstile.render(hostRef.current, {
        sitekey: siteKey,
        callback: (token) => onTokenRef.current(token),
        'expired-callback': () => onTokenRef.current(''),
        'error-callback': () => onTokenRef.current(''),
      });
    }

    if (window.turnstile) {
      renderWidget();
    } else {
      let script = document.querySelector('script[data-turnstile="1"]');
      if (!script) {
        script = document.createElement('script');
        script.src = SCRIPT_SRC;
        script.async = true;
        script.dataset.turnstile = '1';
        document.head.appendChild(script);
      }
      script.addEventListener('load', renderWidget);
    }

    return () => {
      cancelled = true;
      if (widgetId != null && window.turnstile) {
        window.turnstile.remove(widgetId);
      }
    };
  }, [siteKey]);

  if (!siteKey) return null;
  return <div ref={hostRef} className="min-h-11" />;
}
